import styled from 'styled-components';

// export const Flex1 = styled.div`
//   flex: 1;
// `;

export const Wrapper = styled.div`
  padding: 0;
`;

export const ParentTable = styled.div`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: 0px 15px 50px rgba(160, 163, 189, 0.1);
  border-radius: 10px;
  padding: ${({ theme }) => theme.spacing.x3};
`;

export const ParentSearch = styled.div`
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    width: 100%;
  }
`;

export const PageTitle = styled.div`
  h2 {
    margin-bottom: 0 !important;
  }
  @media (max-width: ${({ theme }) => theme.media.xs}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      margin-bottom: ${({ theme }) => theme.spacing.x2} !important;
    }
  }
`;
